import React, { useContext, useEffect, useState } from "react";
import "./AskLocation.css";
import { LoadingContext } from "../../context/LoadingContext";
import { TitleContext } from "../../context/TitleContext";
import { Button } from "react-bootstrap";
import locationIcon from "../../assets/images/icons/location.svg";
import { useLocation, useNavigate } from "react-router-dom";
import { routeNames } from "../../constants/routeNames";

export const AskLocation = (props) => {
  const { setTitle } = useContext(TitleContext);
  const { setLoading } = useContext(LoadingContext);
  const [userData, setUserData] = useState({});
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (location?.state?.redirected && location?.state?.userData) {
      setTitle("SELECT YOUR LOCATION");
      setUserData(location?.state?.userData);
      setLoading(false);
    } else {
      navigate(routeNames.LANDING);
    }
  }, []);

  const onLocationSuccess = (pos) => {
    setLoading(true);
    const crd = pos.coords;
    navigate(routeNames.VENUES, {
      state: {
        redirected: true,
        userData: userData,
        locationPermission: true,
        coordinates: crd
          ? {
              longitude: crd.longitude,
              latitude: crd.latitude,
            }
          : null,
      },
    });
  };

  const noLocation = (err) => {
    setLoading(true);
    navigate(routeNames.VENUES, {
      state: {
        redirected: true,
        userData: userData,
        locationPermission: false,
        coordinates: null,
        locationDenied: true,
      },
    });
  };

  const toVenuesDropdown = (err) => {
    setLoading(true);
    navigate(routeNames.VENUES, {
      state: {
        redirected: true,
        userData: userData,
        locationPermission: false,
        coordinates: null,
      },
    });
  };

  const redirect = () => {
    const options = {
      enableHighAccuracy: true,
      timeout: 5000,
      maximumAge: 0,
    };
    navigator.geolocation.getCurrentPosition(
      onLocationSuccess,
      noLocation,
      options
    );
  };

  return (
    <div>
      <h2
        className="title register-title"
        style={{ fontWeight: 400, marginBottom: "16px" }}
      >
        Use your current location, or see all locations and select your Greene
        King Pub.
      </h2>
      <div className="text-center">
        <div className="mx-auto d-flex justify-content-center ">
          <Button
            onClick={redirect}
            className="cc-button location-btn width-unset position-relative overflow-hidden d-flex align-items-center"
            style={{ padding: "0px 0px" }}
          >
            <div
              className="d-flex align-items-center"
              style={{
                borderRight: "1px solid",
                borderRightColor: "white",
                height: "100%",
                paddingRight: "15px",
              }}
            >
              <img
                src={locationIcon}
                alt="location-icon"
                className="align-self-center location-icon"
                style={{ display: "block" }} // Set a fixed height for the icon
              />
            </div>
            <span style={{ marginLeft: "15px" }} id="location-btn-text">
              Choose a location nearby
            </span>
          </Button>
        </div>
        <p className="location-description m-0">or</p>

        <Button
          onClick={toVenuesDropdown}
          className="cc-button location-btn width-unset mb-0"
        >
          Show me all venues
        </Button>
      </div>
    </div>
  );
};
